import React, { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import axios from "axios";
import "./Weather.css";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function search() {
    const apiKey = "00a6bfb9b6053b4664t55oaa8c181e51";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}`;
    axios.get(apiUrl).then(handleResponse);
  }

   function handleResponse(response) {
    let currentTime = new Date(response.data.time * 1000);
    let timeZoneOffset = currentTime.getTimezoneOffset() 
    let offsetHours = timeZoneOffset / 60
    let adjustedTime = new Date(response.data.dt * 1000 + offsetHours * 3600 * 1000)
    
    setWeatherData({
      ready: true,
      
  ready: true,
      temperature: response.data.temperature,
      condition: response.data.condition.description,
      humidity: response.data.temperature.humidity,
      wind: response.data.wind.speed,
      icon: response.data.condition.icon,
      iconUrl: response.data.condition.icon_url,
      city: response.data.city,
      date: adjustedTime,
    });
   
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather hero">
        <header>
        <form className="form-control"onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-8">
              
              <input
                type="search"
                placeholder="Enter a city, i.e., London or Paris"
                className="form-control"
                autoFocus="on"
                onChange={handleCityChange}
              />
            </div>
            <div className="col-4">
              <input
                type="submit"
                value="Search"
                className="btn d-grid custom-btn w-100 ml-0"
              />
            </div>
          
          </div>
        </form>
        <WeatherInfo data={weatherData} />
        <hr />
        <WeatherForecast city={weatherData.city}/>
        <hr />
        </header>
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}